import React from "react";
import Alert from "@mui/material/Alert";

import useCourtBooking from "./useCourtBooking";
import useCourtScrollSpy from "./useCourtScrollSpy";
import CourtsMobileLayout from "./CourtsMobileLayout";
import CourtsDesktopLayout from "./CourtsDesktopLayout";

function CourtsView() {
  const court = useCourtBooking();
  const scrollSpy = useCourtScrollSpy({
    isMobile: court.isMobile,
    bucketedSlots: court.bucketedSlots,
    hasSuggested: court.suggestedGroups.length > 0
  });

  if (court.courtServices.length === 0 && !court.loading) {
    return <Alert severity="info">No court booking services are currently available.</Alert>;
  }

  return court.isMobile ? <CourtsMobileLayout court={court} scrollSpy={scrollSpy} /> : <CourtsDesktopLayout court={court} />;
}

export default CourtsView;
